import { Logotype } from './Logo.styled';

const Logo = () => <Logotype aria-label="Site logotype">br</Logotype>;
export default Logo;
